var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("main", { attrs: { role: "main" } }, [_c("core-view")], 1),
      _vm._v(" "),
      _c("core-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }